import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { EXPERT_REPORT_COMPARE_WITH, useExportFileDownload } from '@features/expertReports'
import type { ReportExportFormat } from '@features/expertReports'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { NotificationKeys } from '../../../enums/notificationKeys'
import { EXPERT_BALANCE_SHEET_COMPARE_COUNT, fetchExpertBalanceSheetExport } from '../query-api'
import { useExpertBalanceSheetPeriod } from './useExpertBalanceSheetPeriod'

interface UseDownloadExpertBalanceSheetExportResult {
  downloadExport: (format: ReportExportFormat) => Promise<void>
  isExporting: boolean
}

export const useDownloadExpertBalanceSheetExport = (): UseDownloadExpertBalanceSheetExportResult => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()
  const { encodedPeriod: period } = useExpertBalanceSheetPeriod()

  const fetchExport = useCallback(
    (format: ReportExportFormat) =>
      fetchExpertBalanceSheetExport({
        compareCount: EXPERT_BALANCE_SHEET_COMPARE_COUNT,
        compareWith: EXPERT_REPORT_COMPARE_WITH,
        format,
        organizationId: organization?.id ?? '',
        period,
      }),
    [organization?.id, period],
  )

  return useExportFileDownload({
    errorMessage: t('expert_balance_sheet.export.error'),
    fetchExport,
    isReady: !!organization?.id && !!period,
    notificationKey: NotificationKeys.ExpertBalanceSheetExport,
  })
}
